import React, { Fragment, useMemo } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { Banners } from './Banners';
import Navbar, { desktopLinks } from './Navbar';

export default function Layout({
  children,
  title: pageTitle,
  isMobileView = false,
}: {
  children: React.ReactNode;
  title?: string;
  isMobileView?: boolean;
}) {
  const { pathname } = useRouter();
  const isMarketPageActive = useMemo(
    () => desktopLinks.left.find((link) => link.children === 'Market' && link.isActive(pathname)),
    [pathname],
  );

  return (
    <>
      {pageTitle && (
        <Head>
          <title>{pageTitle}</title>
          <meta property="og:title" content={pageTitle} key="title" />
        </Head>
      )}

      <div
        className="grid min-h-screen w-full grid-rows-[auto_1fr] bg-cf-gray-2"
        style={{ marginTop: 'var(--banner-height)' }}
      >
        <div>
          <Banners isMobileView={isMobileView} />
          <Navbar
            logoHref="/portfolio"
            isMobileView={isMobileView}
            className={classNames(isMobileView && '!z-0', 'border-b border-b-cf-gray-3')}
          />
        </div>
        {isMarketPageActive ? (
          children
        ) : (
          <div className="flex w-screen justify-center">
            <div className="w-full px-8 py-10 2xl:container">{children}</div>
          </div>
        )}
      </div>
    </>
  );
}
